import styled from "styled-components"
import GridContainer from "@/components/common/GridContainer"
import HowWeHelpTile from "@/components/TilesModule/variants/HowWeHelp/HowWeHelpTile"
import { useIsDesktop } from "@/hooks/useDevice"
import { groupArrayBySize } from "@/utils/utils"
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"
import useColor from "@/hooks/useColor"
import { colors } from "@/styles/themeSettings"

const StyledWrapper = styled.section`
	color: ${(props) => props.theme.colors.richBlack};
	background: ${({ $backgroundColor }) => $backgroundColor};
`

const StyledRow = styled(GridContainer)`
	margin-bottom: var(--grid-gap);
`

const VARIANT = {
	INDENT: "indent",
	NO_INDENT: "no-indent",
}

export default function HowWeHelp({ data, paddings, headerDescription }) {
	const isDesktop = useIsDesktop()
	const backgroundColor = useColor(data?.backgroundColor?.color || colors.white)
	const variant = data?.variant || VARIANT.INDENT
	const borderColor = backgroundColor === colors.platinum ? colors.slateGray : null

	const id = data?.id || ""
	const items = data?.tiles || []
	const groupedItems = groupArrayBySize(items, variant === VARIANT.INDENT ? 3 : 4)

	return (
		<StyledWrapper id={id} className={paddings} $backgroundColor={backgroundColor}>
			<HeaderDescriptionBlock headerDescription={headerDescription} borderColor={borderColor} />
			{isDesktop && variant === VARIANT.INDENT ? (
				groupedItems.map((group, index) => (
					<StyledRow className="indent-desktop-1" key={index}>
						{group.map((item, index) => {
							const key = item?.id || index
							return <HowWeHelpTile item={item} key={key} />
						})}
					</StyledRow>
				))
			) : (
				<StyledRow>
					{items.map((item, index) => {
						const key = item?.id || index
						return <HowWeHelpTile item={item} key={key} />
					})}
				</StyledRow>
			)}
		</StyledWrapper>
	)
}
